import React from "react"
import CaseStudy from "./case-study"
import { getImage, GatsbyImage } from "gatsby-plugin-image"
import FixedNav from "./fixed-nav"
import ReadyForE2E from "../ready-for-e2e"

const CaseStudyTemplate = ({ mod, caseStudies, previous, next }) => {
  const backgroundImage = getImage(mod.backgroundImage)
  return (
    <section>
      <div id="caseStudy" className="container positionRelative">
        <div>
          <GatsbyImage
            alt={mod.backgroundImage.title}
            image={backgroundImage}
          />
        </div>
        <div className="moduleContainer">
          <div style={{ width: "100%" }}>
            <CaseStudy mod={mod} />
            <FixedNav
              mod={mod}
              caseStudies={caseStudies}
              previous={previous}
              next={next}
            />
          </div>
        </div>
      </div>
      <ReadyForE2E />
    </section>
  )
}

export default CaseStudyTemplate
